export const INTEGRATIONS = {
  frontapp: {
    id: 'frontapp',
    label: {
      long: 'label.FRONTAPP',
      short: 'label.FRONTAPP'
    }
  },
  hubspot: {
    id: 'hubspot',
    label: {
      long: 'label.HUBSPOT',
      short: 'label.HUBSPOT'
    }
  },
  outreach: {
    id: 'outreach',
    label: {
      long: 'label.OUTREACH',
      short: 'label.OUTREACH'
    }
  },
  salesforce: {
    id: 'salesforce',
    label: {
      long: 'label.SALESFORCE',
      short: 'label.SFDC'
    }
  },
  salesloft: {
    id: 'salesloft',
    label: {
      long: 'label.SALESLOFT',
      short: 'label.SALESLOFT'
    }
  },
  unknown: {
    id: 'unknown',
    label: {
      long: 'label.UNKNOWN',
      short: 'label.UNKNOWN'
    }
  }
};
